import { createBottomTabNavigator, BottomTabBar } from '@react-navigation/bottom-tabs';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { NavigationContainer} from '@react-navigation/native';
import React, { useEffect } from 'react';
import { Image, Linking, Platform, Text, TouchableOpacity, View } from 'react-native';
import AntDesign from 'react-native-vector-icons/AntDesign';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import { Colors } from '../../constants/Colors';
import { Images } from '../../constants/Images';
import Equipment from '../../pages/Equipment/Equipament';
import Bag from '../../pages/Bag/Bag';
import Home from '../../pages/Home/Home';
import Menu from '../../pages/Menu/Menu';
import MenuPage from '../../pages/Menu/MenuPage';
import Orders from '../../pages/Orders/Orders';
import FeaturedProducts from '../../pages/FeaturedProducts/FeaturedProducts';
import { useAuthStore } from '../../store/AuthStore';
import { useUserStore } from '../../store/UserStore';
import { useBagStore } from '../../store/BagStore';
import { useModalStore } from '../../store/MenuModalStore';
import { PrivateStackScreen, PublicStackScreen } from '../Routes';
import Profile from '../../pages/Profile/Profile';
import AppLinkHandler from '../../utils/AppLinkHandler';
import { navigationRef } from '../navigationRef';
import { getAnalytics, logEvent, logScreenView } from '@react-native-firebase/analytics';
import { useIsDesktop } from '../../hooks/useIsDesktop';
import DesktopSidebar from '../../components/DesktopSidebar/DesktopSidebar';

const Tab = createBottomTabNavigator();
const HomeStack = createNativeStackNavigator();

const homeScreen = 'Home';
const MenuScren = 'Menu';
const OrdersScreen = 'Meus pedidos';
const BagScreen = 'Sacola';
const EquipmentsScreen = 'Equipamentos';
const PerfilMenuModal = 'Perfil';
const linking = {
  prefixes: ['awesometest://'],
  config: {
    screens: {
      Home: 'home',
      Debts: 'debts',
      Bag: 'bag',
      Equipamentos: 'equipamentos',
      ProductDetails: 'product_details',

    },
  },
};
const analyticsInstance = getAnalytics();
const getTabIcon = (routeName: string, focused: boolean) => {
  const totalItems = useBagStore(state => state.getTotalItems());
  const { openModal } = useModalStore();
  if (routeName === homeScreen) {
    return focused ? (
      <Image source={Images.houseP} style={{ width: 24, height: 29 }} />
    ) : (
      <Image source={Images.homeIcon} style={{ width: 24, height: 29 }} />
    );
  } else if (routeName === MenuScren) {
    return Platform.OS === 'web' ? (
      <Image
        source={Images.user}
        style={{ width: 24, height: 24, tintColor: focused ? Colors.RedPallete.red : 'gray' }}
      />
    ) : (
      <AntDesign
        name="user"
        size={28}
        color={focused ? Colors.RedPallete.red : 'gray'}
      />
    );
  } else if (routeName === EquipmentsScreen) {
    return (
      <Image
        source={Images.tool}
        style={[{ tintColor: focused ? Colors.RedPallete.red : 'gray' }]}
      />
    );
  } else if (routeName === BagScreen) {
    return focused ? (
      <>
        <Image
          source={Images.bag}
          style={{ width: 22, height: 29, tintColor: Colors.RedPallete.red }}
        />
        {totalItems > 0 && (
          <View
            style={{
              position: 'absolute',
              top: -3,
              right: 25,
              backgroundColor: 'red',
              borderRadius: 8,
              minWidth: 22,
              height: 22,
              justifyContent: 'center',
              alignItems: 'center',
              paddingHorizontal: 2,
            }}>
            <Text
              style={{
                color: 'white',
                fontSize: 10,
                fontFamily: 'TCCC-UnityHeadline Regular',
                textAlign: 'center',
                includeFontPadding: false,
                lineHeight: 14,
              }}>
              {totalItems > 99 ? '99+' : totalItems}
            </Text>
          </View>
        )}
      </>
    ) : (
      <>
        <Image
          source={Images.bag}
          style={{
            width: 22,
            height: 29,
            tintColor: Colors.GrayPallete.lightgrayThree,
          }}
        />
        {totalItems > 0 && (
          <View
            style={{
              position: 'absolute',
              top: -3,
              right: 25,
              backgroundColor: 'red',
              borderRadius: 8,
              minWidth: 22,
              height: 22,
              justifyContent: 'center',
              alignItems: 'center',
              paddingHorizontal: 2,
            }}>
            <Text
              style={{
                color: 'white',
                fontSize: 10,
                fontFamily: 'TCCC-UnityHeadline Regular',
                textAlign: 'center',
                includeFontPadding: false,
                lineHeight: 14,
              }}>
              {totalItems > 99 ? '99+' : totalItems}
            </Text>
          </View>
        )}
      </>
    );
  } else if (routeName === OrdersScreen) {
    return (
      <Image
        source={Images.cart}
        style={[{ marginTop: 6, width: 38, height: 38 }, { tintColor: focused ? Colors.RedPallete.red : 'gray' }]}
      />
    );
  }
};

// Stack Navigator para a tab Home que inclui Home e FeaturedProducts
const HomeStackNavigator = () => {
  return (
    <HomeStack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <HomeStack.Screen name="HomeScreen" component={Home} />
      <HomeStack.Screen name="FeaturedProducts" component={FeaturedProducts} />
    </HomeStack.Navigator>
  );
};

const CustomTabBar = (props: any) => {
  const isDesktop = useIsDesktop();
  if (isDesktop) {
    return <DesktopSidebar {...props} />;
  }
  return <BottomTabBar {...props} />;
};

export const MainTabScreen = () => {
  const { user } = useUserStore();
  const { openModal } = useModalStore();
  const isDesktop = useIsDesktop();

  return (
    <Tab.Navigator
      initialRouteName={homeScreen}
      tabBar={(props) => <CustomTabBar {...props} />}
      sceneContainerStyle={isDesktop ? { marginLeft: 250 } : undefined}
      screenOptions={({ route }) => ({
        sceneStyle: isDesktop ? { marginLeft: 250 } : undefined,
        tabBarIcon: ({ focused }) => getTabIcon(route.name, focused),
        tabBarActiveTintColor: Colors.RedPallete.red,
        tabBarStyle: {
          paddingTop: Platform.OS === 'web' ? 8 : 20,
          paddingBottom: Platform.OS === 'ios' ? 0 : Platform.OS === 'web' ? 8 : 20,
          height: Platform.OS === 'web' ? 52 : 85,
          display: 'flex',
          flexDirection: 'row',
          position: 'absolute',
        },
        tabBarHideOnKeyboard: true,
        tabBarLabelStyle: {
          marginTop: Platform.OS === 'ios' ? 8 : 0,
          fontSize: 10,
          fontFamily: 'TCCC-UnityHeadline Regular',
          lineHeight: 12,
        },
      })}>
      <Tab.Screen
        name="Home"
        component={HomeStackNavigator}
        options={({ route }) => ({
          headerShown: false,
        })}
      />
      {!!user?.storeAccess && (
        <Tab.Screen
          name="Sacola"
          component={Bag}
          options={{
            headerShown: false,
            tabBarStyle: isDesktop ? undefined : { display: `none` },
          }}
        />
      )}
      {!user?.storeAccess && (
        <Tab.Screen
          name="Equipamentos"
          component={Equipment}
          options={{ headerShown: false }}
        />
      )}
            <Tab.Screen
        name="Meus pedidos"
        component={Orders}
        options={{ headerShown: false }}
        listeners={({ navigation, route }) => ({
          tabPress: (e) => {
            logEvent(analyticsInstance, 'orders_click', {
              client_code: user?.clientCode,
            });
          },
        })}
      />
      {!isDesktop && (
        <Tab.Screen
          name="Menu"
          component={Home}
          options={{ headerShown: false }}
          listeners={{
            tabPress: (e) => {
              e.preventDefault();
              openModal();
            },
          }}
        />
      )}
    </Tab.Navigator>
  );
};

export const RoutesTab = () => {
  const { token } = useAuthStore();
  const { user } = useUserStore();
  const routeNameRef = React.useRef();
  const analyticsInstance = getAnalytics();

  return (
    <NavigationContainer 
    ref={navigationRef}
        onReady={() => {
          routeNameRef.current = navigationRef.getCurrentRoute()?.name;
        }}
        onStateChange={async () => {
          const previousRouteName = routeNameRef.current;
          const currentRouteName = navigationRef.getCurrentRoute()?.name;

          if (previousRouteName !== currentRouteName) {
            await logScreenView(analyticsInstance, {
              screen_name: currentRouteName,
              screen_class: currentRouteName,
            });
          }
          routeNameRef.current = currentRouteName;
        }}
    linking={Platform.OS !== 'web' ? linking : undefined}>
      <AppLinkHandler />
      {token && user ? <PrivateStackScreen /> : <PublicStackScreen />}
    </NavigationContainer>
  );
};
